export default __webpack_public_path__ + "static/media/SAL3.8539a1ca.webp";